const API = process.env.REACT_APP_BACKEND_URL;

let _sessionId = null;
let _startTime = Date.now();
let _pagesViewed = [];

function _getSessionId() {
  if (!_sessionId) {
    _sessionId = sessionStorage.getItem("mahra_session_id") || `s_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    sessionStorage.setItem("mahra_session_id", _sessionId);
  }
  return _sessionId;
}

function _getCustomer() {
  try {
    const stored = localStorage.getItem("mahra_customer");
    return stored ? JSON.parse(stored) : null;
  } catch { return null; }
}

export function trackEvent(event, outfitId = "", metadata = {}) {
  const customer = _getCustomer();
  fetch(`${API}/api/analytics/track`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(customer?.customer_id ? { "x-customer-id": customer.customer_id } : {}),
    },
    body: JSON.stringify({
      event,
      outfit_id: outfitId,
      session_id: _getSessionId(),
      ...metadata,
    }),
  }).catch(() => {});
}

export function trackPageView(path, title = "") {
  const customer = _getCustomer();
  const page = { path, title, time: new Date().toISOString() };
  _pagesViewed.push(page);

  fetch(`${API}/api/analytics/track`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(customer?.customer_id ? { "x-customer-id": customer.customer_id } : {}),
    },
    body: JSON.stringify({
      event: "page_view",
      session_id: _getSessionId(),
      metadata: {
        path,
        title,
        referrer: document.referrer || "",
        user_agent: navigator.userAgent,
        screen: `${window.screen.width}x${window.screen.height}`,
        customer_name: customer?.name || "",
        customer_email: customer?.email || "",
      },
    }),
  }).catch(() => {});
}

export function trackSessionEnd() {
  const durationSec = Math.round((Date.now() - _startTime) / 1000);
  const customer = _getCustomer();

  navigator.sendBeacon(`${API}/api/analytics/track`, JSON.stringify({
    event: "session_end",
    session_id: _getSessionId(),
    metadata: {
      duration_seconds: durationSec,
      pages_viewed: _pagesViewed.length,
      customer_name: customer?.name || "",
      customer_email: customer?.email || "",
    },
  }));
}

// Track session end on page unload
if (typeof window !== "undefined") {
  window.addEventListener("beforeunload", trackSessionEnd);
}

// ─── Google Ads / GA4 gtag helpers ───

function _gtag(...args) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
}

/** Fire once per page load — prevents duplicate conversion fires */
const _firedConversions = new Set();

/**
 * Google Ads conversion — fires ONLY once per bookingId.
 * Replace CONVERSION_LABEL with the label from Google Ads once generated.
 */
export function gtagConversion(bookingId, totalPrice) {
  if (_firedConversions.has(bookingId)) return;
  _firedConversions.add(bookingId);
  _gtag("event", "conversion", {
    send_to: "AW-18044080884/mZDrCMevs5AcEPSli5xD",
    value: totalPrice,
    currency: "AUD",
    transaction_id: bookingId,
  });
}

/** add_to_cart event */
export function gtagAddToCart(itemPrice, itemName = "") {
  _gtag("event", "add_to_cart", {
    value: itemPrice,
    currency: "AUD",
    items: [{ item_name: itemName, price: itemPrice }],
  });
}

/** begin_checkout event */
export function gtagBeginCheckout(cartValue) {
  _gtag("event", "begin_checkout", {
    value: cartValue,
    currency: "AUD",
  });
}

/** page_view for GA4 (SPA navigation) */
export function gtagPageView(path, title) {
  _gtag("event", "page_view", {
    page_path: path,
    page_title: title,
  });
}
